import { Box, Typography, Chip, LinearProgress } from "@mui/material";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import styled from "styled-components";

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  // boxShadow: theme.shadows[1], // Optional: Add shadow
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.1rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

export const WorkerName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1rem',
  color: theme.palette.text.primary,
}));

export const WorkerId = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
}));

interface StatusChipProps {
  $isError?: boolean;
}

export const StatusChip = styled(Chip)<StatusChipProps>(({ theme, $isError }) => ({
  backgroundColor: $isError ? '#FFEBEE' : theme.palette.success.light,
  color: $isError ? '#D32F2F' : theme.palette.success.dark,
  fontWeight: 600,
  fontSize: '0.75rem',
  height: '24px',
}));

export const DurationText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.875rem',
  color: theme.palette.text.primary,
  textAlign: 'right',
  marginBottom: theme.spacing(1),
}));

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  backgroundColor: theme.palette.grey[200],
  '& .MuiLinearProgress-bar': {
    borderRadius: 5,
    backgroundColor: theme.palette.success.light,
  },
}));

export const TimeLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
}));

export const TimeValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1rem',
  color: theme.palette.text.primary,
}));

export const CountdownBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#F4F6F8', // Light grey background
  borderRadius: 7,
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

export const CountdownText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.95rem',
  color: '#637381',
}));

export const StyledWarningIcon = styled(WarningAmberRoundedIcon)(({ theme }) => ({
  color: '#637381',
  fontSize: '1.5rem',
  marginTop: '-1px',
}));